// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/store_payment/v1/store_payment.proto (package fingertip.creator.store_payment.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CancelStripePaymentIntentPublicRequest, CancelStripePaymentIntentPublicResponse, CheckIppsPaymentStatusPublicRequest, CheckIppsPaymentStatusPublicResponse, CreateIppsQrPaymentPublicRequest, CreateIppsQrPaymentPublicResponse, CreateStripeBookingPaymentIntentPublicRequest, CreateStripeBookingPaymentIntentPublicResponse, CreateStripeBookingSetupIntentPublicRequest, CreateStripeBookingSetupIntentPublicResponse, CreateStripeInvoicePaymentIntentPublicRequest, CreateStripeInvoicePaymentIntentPublicResponse, CreateStripePaymentIntentPublicRequest, CreateStripePaymentIntentPublicResponse, CreateStripeSetupIntentPublicRequest, CreateStripeSetupIntentPublicResponse, GetPaymentComputationPublicRequest, GetPaymentComputationPublicResponse, GetStorePaymentComputationPublicRequest, GetStorePaymentComputationPublicResponse, GetStorePaymentPublicRequest, GetStorePaymentPublicResponse, GetStorePaymentsRequest, GetStorePaymentsResponse, GetStripeBookingPaymentAmountPublicRequest, GetStripeBookingPaymentAmountPublicResponse, UpdateStripeBookingPaymentIntentPublicRequest, UpdateStripeBookingPaymentIntentPublicResponse, UpdateStripeBookingSetupIntentPublicRequest, UpdateStripeBookingSetupIntentPublicResponse, UpdateStripePaymentIntentPublicRequest, UpdateStripePaymentIntentPublicResponse } from "./store_payment_pb.js";

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.CreateStripePaymentIntentPublic
 */
export const createStripePaymentIntentPublic = {
  localName: "createStripePaymentIntentPublic",
  name: "CreateStripePaymentIntentPublic",
  kind: MethodKind.Unary,
  I: CreateStripePaymentIntentPublicRequest,
  O: CreateStripePaymentIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.CreateStripeInvoicePaymentIntentPublic
 */
export const createStripeInvoicePaymentIntentPublic = {
  localName: "createStripeInvoicePaymentIntentPublic",
  name: "CreateStripeInvoicePaymentIntentPublic",
  kind: MethodKind.Unary,
  I: CreateStripeInvoicePaymentIntentPublicRequest,
  O: CreateStripeInvoicePaymentIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.CreateStripeBookingPaymentIntentPublic
 */
export const createStripeBookingPaymentIntentPublic = {
  localName: "createStripeBookingPaymentIntentPublic",
  name: "CreateStripeBookingPaymentIntentPublic",
  kind: MethodKind.Unary,
  I: CreateStripeBookingPaymentIntentPublicRequest,
  O: CreateStripeBookingPaymentIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.CreateStripeBookingSetupIntentPublic
 */
export const createStripeBookingSetupIntentPublic = {
  localName: "createStripeBookingSetupIntentPublic",
  name: "CreateStripeBookingSetupIntentPublic",
  kind: MethodKind.Unary,
  I: CreateStripeBookingSetupIntentPublicRequest,
  O: CreateStripeBookingSetupIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.UpdateStripeBookingPaymentIntentPublic
 */
export const updateStripeBookingPaymentIntentPublic = {
  localName: "updateStripeBookingPaymentIntentPublic",
  name: "UpdateStripeBookingPaymentIntentPublic",
  kind: MethodKind.Unary,
  I: UpdateStripeBookingPaymentIntentPublicRequest,
  O: UpdateStripeBookingPaymentIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.UpdateStripeBookingSetupIntentPublic
 */
export const updateStripeBookingSetupIntentPublic = {
  localName: "updateStripeBookingSetupIntentPublic",
  name: "UpdateStripeBookingSetupIntentPublic",
  kind: MethodKind.Unary,
  I: UpdateStripeBookingSetupIntentPublicRequest,
  O: UpdateStripeBookingSetupIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.CreateStripeSetupIntentPublic
 */
export const createStripeSetupIntentPublic = {
  localName: "createStripeSetupIntentPublic",
  name: "CreateStripeSetupIntentPublic",
  kind: MethodKind.Unary,
  I: CreateStripeSetupIntentPublicRequest,
  O: CreateStripeSetupIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.GetStripeBookingPaymentAmountPublic
 */
export const getStripeBookingPaymentAmountPublic = {
  localName: "getStripeBookingPaymentAmountPublic",
  name: "GetStripeBookingPaymentAmountPublic",
  kind: MethodKind.Unary,
  I: GetStripeBookingPaymentAmountPublicRequest,
  O: GetStripeBookingPaymentAmountPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * To Deprecate
 *
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.GetStorePaymentComputationPublic
 */
export const getStorePaymentComputationPublic = {
  localName: "getStorePaymentComputationPublic",
  name: "GetStorePaymentComputationPublic",
  kind: MethodKind.Unary,
  I: GetStorePaymentComputationPublicRequest,
  O: GetStorePaymentComputationPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.GetPaymentComputationPublic
 */
export const getPaymentComputationPublic = {
  localName: "getPaymentComputationPublic",
  name: "GetPaymentComputationPublic",
  kind: MethodKind.Unary,
  I: GetPaymentComputationPublicRequest,
  O: GetPaymentComputationPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.CancelStripePaymentIntentPublic
 */
export const cancelStripePaymentIntentPublic = {
  localName: "cancelStripePaymentIntentPublic",
  name: "CancelStripePaymentIntentPublic",
  kind: MethodKind.Unary,
  I: CancelStripePaymentIntentPublicRequest,
  O: CancelStripePaymentIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.UpdateStripePaymentIntentPublic
 */
export const updateStripePaymentIntentPublic = {
  localName: "updateStripePaymentIntentPublic",
  name: "UpdateStripePaymentIntentPublic",
  kind: MethodKind.Unary,
  I: UpdateStripePaymentIntentPublicRequest,
  O: UpdateStripePaymentIntentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.GetStorePayments
 */
export const getStorePayments = {
  localName: "getStorePayments",
  name: "GetStorePayments",
  kind: MethodKind.Unary,
  I: GetStorePaymentsRequest,
  O: GetStorePaymentsResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.GetStorePaymentPublic
 */
export const getStorePaymentPublic = {
  localName: "getStorePaymentPublic",
  name: "GetStorePaymentPublic",
  kind: MethodKind.Unary,
  I: GetStorePaymentPublicRequest,
  O: GetStorePaymentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.CreateIppsQrPaymentPublic
 */
export const createIppsQrPaymentPublic = {
  localName: "createIppsQrPaymentPublic",
  name: "CreateIppsQrPaymentPublic",
  kind: MethodKind.Unary,
  I: CreateIppsQrPaymentPublicRequest,
  O: CreateIppsQrPaymentPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_payment.v1.StorePaymentService.CheckIppsPaymentStatusPublic
 */
export const checkIppsPaymentStatusPublic = {
  localName: "checkIppsPaymentStatusPublic",
  name: "CheckIppsPaymentStatusPublic",
  kind: MethodKind.Unary,
  I: CheckIppsPaymentStatusPublicRequest,
  O: CheckIppsPaymentStatusPublicResponse,
  service: {
    typeName: "fingertip.creator.store_payment.v1.StorePaymentService"
  }
};
